export default __webpack_public_path__ + "static/media/com_send_btn.750b9aee.svg";